import React from 'react';

const Terms = () => {
    return (
        <div className={'px-2 md:px-52 py-5'}>
            <p className={'text-4xl font-black py-2'}>
               Term of Use
            </p>
            <p>
                PLEASE READ THIS END USER LICENSE AGREEMENT (EULA) CAREFULLY BEFORE ACCESSING OR USING ANY APPS, for
                this End User License Agreement governs your use of Apps ("Products") and how we provide the Apps.
            </p>
            <p className={'text-xl font-bold py-2'}>
                AGREEMENT TO TERMS
            </p>
            <ul>
                <li className={'list-disc'}>
                    By using our Apps, you agree to be bound by these Terms. If you don't agree to be bound by these
                    Terms, do not use the Products.
                </li>
                <br/>
                <li className={'list-disc'}>
                    We may change, modify, add or delete these terms and conditions at any time. If the changes include
                    material changes that affect your rights or obligations, we will notify you of the changes by
                    reasonable means.
                </li>
            </ul>
            <p className={'text-xl font-bold py-2'}>
                AGE REQUIREMENT
            </p>
            <ul>
                <li className={'list-disc'}>
                    You must be 13 years of or older to install or to use the Coderb (individual) Apps. If you
                    are at least 13 but not yet 18 years of age, please have your parent or legal guardian review this
                    EULA with you, discuss any questions you might have, and install the Coderb (individual) Apps
                    for you.
                </li>
            </ul>
            <p className={'text-xl font-bold py-2'}>
                GRANT OF LICENSE
            </p>
            <ul>
                <li className={'list-disc'}>
                    3.1. Subject to your compliance with the terms and conditions of this EULA, we grant you a limited,
                    non-exclusive, revocable, non-sublicensable, non-transferable license, to access, download and
                    install the most current generally available version of the Coderb (individual) Apps on a
                    single, authorized mobile device that you own or control solely for your lawful, personal, and
                    non-commercial entertainment use.
                </li>
                <br/>

                <li className={'list-disc'}>
                    3.2. ACCEPTING THE LICENSE AGREEMENT BY CLICKING ON THE APPROPRIATE BUTTON BELOW, OR BY DOWNLOADING,
                    INSTALLATION, ACTIVATION OR USE THE SOFTWARE, YOU ACKNOWLEDGE THAT YOU HAVE READ THIS AGREEMENT,
                    UNDERSTAND ITS CONTENTS AND AGREE TO BE BOUND BY ITS TERMS AND CONDITIONS. If you do not agree to
                    the terms and conditions of this EULA, do not install or use any App.
                    <br/>
                    We may change, modify, add or delete these terms and conditions at any time. If the changes include
                    material changes that affect your rights or obligations, we will notify you of the changes by
                    reasonable means.
                </li>
                <br/>

                <li className={'list-disc'}>
                    3.3. Certain Coderb (individual) Apps on the Apple App Store and Google Play Store will allow
                    you to obtain the benefit of the application on a subscription basis. Payment for such a
                    subscription (which may be for example daily, weekly, monthly, tri-monthly or yearly) may be
                    processed in the application, by third parties who act on our behalf or directly by the mobile
                    platform owner (e.g. Apple or Google). Free trial subscriptions may be cancelled at any point up to
                    24 hours before the expiry of the free trial (Apple) or at any time before the end of the trial
                    period (Google). You can cancel a subscription service at any time during the subscription period
                    via the subscription settings in your iTunes or Android account. The cancellation will take effect
                    after the last day in the relevant subscription period.
                    <br/>
                    Please note: your free-trial subscription will automatically renew as a paid subscription unless
                    auto-renew is turned off at least 24 hours before the end of the free-trial subscription period
                    (Apple) or you cancel before the end of the trial period (Google).
                </li>
                <br/>

                <li className={'list-disc'}>
                    3.4. Through your use of Coderb (individual) Apps, you may accrue virtual "Coins" that may be
                    used and virtually spent in the App environment. Coins are a limited license right distributed at
                    our discretion, may only be used with respect to virtual items and services made available in the
                    App environment, and are not redeemable for monetary value.
                    <br/>

                    In addition to the Coins that you may virtually accrue, you may also purchase Coins. Payments for
                    Coins may be made through an in-app purchase. Please note: we may limit the number of Coins or the
                    total monetary value of Coins that you may purchase at one time, or over a given period of time, in
                    our sole discretion.
                    <br/>

                    Newly purchased Coins credits may not be available for immediate use. If you make any unauthorized
                    purchases of Coins, or if any of your purchase of Coins leads to charge-reversals, chargebacks,
                    disputed charges, dispute fees, or any allegation of payment fraud, we may terminate your account,
                    with or without notice, in our sole and absolute discretion.
                    <br/>

                    All purchases of Coins are FINAL and non-refundable, except in our sole and absolute discretion.
                    Once you purchase Coins, you cannot return them. If your account is cancelled or terminated by you
                    or by us, for any reason, you will lose and forfeit any outstanding Coins.
                    <br/>

                    The virtual items that you may virtually acquire or use in the App environment are a limited license
                    right granted by us and you do not acquire any ownership right to any such virtual items. We may
                    terminate such license right and withdraw or discontinue any virtual item in the Site environment or
                    may remove your right to use any particular virtual item or service. Any exchanges of coins for
                    virtual items are non-reversible.
                    <br/>

                    You agree that you will not gain any right, title or interest whatsoever in the Coins, or virtual
                    items or services, and that you may not trade, sell, transfer or transact Coins, or virtual items or
                    services in any manner except as permitted in the App environment.
                    <br/>

                    You may not sell or trade the time taken to accrue Coins. Any transaction in Coins or virtual items
                    or services via online auction sites or other channels outside the Services is strictly prohibited.
                    You may not use cheat programs, including non-Coderb (individual) Apps software programs, to
                    accrue Coins or virtually acquire Coins. We may immediately terminate your account if it comes to
                    our attention that you have accrued, virtually acquired or used Coins in any non-permitted manner.
                </li>
            </ul>
            <p className={'text-xl font-bold py-2'}>
                DISCLAIMER
            </p>
            <ul>
                <li className={'list-disc'}>
                    THE APP AND CONTENT ARE PROVIDED "AS IS," WITHOUT WARRANTY OF ANY KIND. WITHOUT LIMITING THE
                    FOREGOING, WE EXPLICITLY DISCLAIM ANY WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
                    PURPOSE, QUIET ENJOYMENT OR NON-INFRINGEMENT, AND ANY WARRANTIES ARISING OUT OF COURSE OF DEALING OR
                    USAGE OF TRADE. We make no warranty that the App will meet your requirements or be available on an
                    uninterrupted, secure, or error-free basis. We make no warranty regarding the quality, accuracy,
                    timeliness, truthfulness, completeness or reliability of any Content.
                </li>
                <br/>
                <li className={'list-disc'}>
                    Coderb (individual) Apps, like other consumer technologies, may not be 100% secure. By
                    accepting this EULA you acknowledge and accept that the Coderb (individual) Apps and any
                    information you download or offer to share by means of an Coderb (individual) App, may be
                    exposed to unauthorized access, interception, corruption, damage or misuse, and cannot be regarded
                    as 100% secure. You accept all responsibility for such security risks and any damage resulting
                    therefrom. Further, you are solely responsible for securing your mobile device from unauthorized
                    access, including by such means as using complex password protection and, for Android users,
                    enabling device encryption in your settings. You agree that Coderb (individual) shall not be
                    liable for any unauthorized access to your mobile device or the app data thereon.
                </li>
            </ul>
            <p className={'text-xl font-bold py-2'}>
                THIRD-PARTY SERVICES AND CONTENT
            </p>
            <ul>
                <li className={'list-disc'}>
                    5.1. The Coderb (individual) Apps may integrate, be integrated into, bundled, or be provided
                    in connection with third-party services, advertising, feeds, and/or content. If you are installing
                    an Coderb (individual) App that includes third party services and third party content, such
                    services and content are subject to such third party's terms of services and privacy policies, which
                    may be found on the relevant Third Party Partner's website. Coderb (individual) Apps may
                    provide access or links to Third Party Partner websites or resources. We have no control over such
                    websites and resources, and you acknowledge and agree that Coderb (individual) is not
                    responsible for the availability of such external websites or resources, and does not endorse nor is
                    responsible or liable for any content, advertising, products, or other materials on or available
                    from such websites or resources. You further acknowledge and agree that we will not be responsible
                    or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in
                    connection with use of or reliance on any such Content (as defined below), goods or services
                    available on or through any such website or resource.
                </li>
                <br/>
                <li className={'list-disc'}>
                    5.2. All services, advertising, feeds and content, including without limitation, all data, links,
                    articles, graphic or video messages and all information, text, software, music, sound, graphics or
                    other materials ("Content") made available or accessible through an Coderb (individual) App,
                    whether publicly available or privately transmitted, is the sole responsibility of the entity or
                    person from whom it originated. You hereby acknowledge and agree that by using an Digital Partner
                    Group GmbH App you may be exposed to Content that may be offensive, indecent or objectionable in
                    your community. You agree to accept all risks associated with the use of any Content, including any
                    reliance on the accuracy or completeness of such Content. Under no circumstances will we be liable
                    in any way for any Content created by or originating with entities other than Digital Partner Group
                    GmbH, including, but not limited to, any errors or omissions in any such Content, or for loss or
                    damage of any kind incurred as a result of the transmission or posting of such Content by means of
                    an Coderb (individual) App.
                </li>
            </ul>
            <p className={'text-xl font-bold py-2'}>
                INDEMNITY </p>
            <ul>
                <li className={'list-disc'}>
                    You will indemnify and hold harmless Coderb (individual) and its officers, directors,
                    employee and agents, from and against any claims, disputes, demands, liabilities, damages, losses,
                    and costs and expenses, including, without limitation, reasonable legal and accounting fees arising
                    out of or in any way connected with your access to or use of the App or Content, your User Content,
                    or your violation of these Terms.
                </li>

            </ul>
            <p className={'text-xl font-bold py-2'}>
                PRIVACY POLICY
            </p>
            <ul>
                <li className={'list-disc'}>
                    Please refer to our <a className={'underline'}
                                           href={'https://rbtechlab.in/farmmasterprivacypolicy.html'}>Privacy
                    Policy</a> for information on how we
                    collect, use and disclose information from our users.
                </li>

            </ul>
            <p className={'text-xl font-bold py-2'}>
                GOVERNING LAW
            </p>
            <ul>
                <li className={'list-disc'}>
                    These Terms and any action related thereto will be governed by the laws of the Germany without
                    regard to its conflict of laws provisions.
                </li>
                <br/>
                <li className={'list-disc'}>
                    8.1 Agreement to Arbitrate
                </li>
                <br/>
                <li className={'list-disc'}>
                    You and Coderb (individual) agree that any dispute, claim or controversy arising out of or
                    relating to these Terms or the breach, termination, enforcement, interpretation or validity thereof
                    or the use of the App or Content (collectively, " Disputes") will be settled by binding arbitration,
                    except that each party retains the right: to bring an individual action in small claims court and to
                    seek injunctive or other equitable relief in a court of competent jurisdiction to prevent the actual
                    or threatened infringement, misappropriation or violation of a party's copyrights, trademarks, trade
                    secrets, patents or other intellectual property.
                </li>
                <br/>
                <li className={'list-disc'}>
                    Without limiting the preceding sentence, you will also have the right to litigate any other Dispute
                    if you provide Coderb (individual) with written notice of your desire to do so by at
                    devloperrb73375@gmail.com within thirty (30) days following the date you first agree to these Terms
                    (such notice, an "Arbitration Opt-out Notice"). If you don't provide Coderb (individual) with
                    an Arbitration Opt-out Notice within the thirty (30) day period, you will be deemed to have
                    knowingly and intentionally waived your right to litigate any Dispute. The exclusive jurisdiction
                    and venue of any IP Protection Action or, if you timely provide Coderb (individual) with an
                    Arbitration Opt-out Notice, will be the state and federal courts located in the Germany and each of
                    the parties hereto waives any objection to jurisdiction and venue in such courts.
                </li>
                <br/>
                <li className={'list-disc'}>
                    Unless you timely provide Coderb (individual) with an Arbitration Opt-out Notice, you
                    acknowledge and agree that you and Coderb (individual) are each waiving the right to a trial
                    by jury or to participate as a plaintiff or class member in any purported class action or
                    representative proceeding. Further, unless both you and Coderb (individual) otherwise agree
                    in writing, the arbitrator may not consolidate more than one person's claims, and may not otherwise
                    preside over any form of any class or representative proceeding.
                </li>
                <br/>
                <li className={'list-disc'}>
                    If this specific paragraph is held unenforceable, then the entirety of this "Dispute Resolution"
                    section will be deemed void. Except as provided in the preceding sentence, this "Dispute Resolution"
                    section will survive any termination of these Terms.
                </li>

            </ul>
            <p className={'text-xl font-bold py-2'}>
                CONTACTS
            </p>
            <ul>
                <li className={'list-disc'}>
                    If you have any questions about this EULA, please contact us by email as follows:
                </li>
                <br/>
                <li className={'list-disc'}>
                    email: devloperrb73375@gmail.com
                </li>
            </ul>
        </div>
    );
};

export default Terms;
